import React from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo.png";

const FooterSection = () => {
  const quickLinksCol1 = [
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Blog", path: "/blog" },
  ];
  const quickLinksCol2 = [
    { label: "Contact", path: "/contact" },
    { label: "Influencer", path: "/influencer" },
    { label: "UpSkill", path: "/upskill" },
  ];

  return (
    <footer className="bg-white border-t border-[#F1F3F1] w-full relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 pt-24 pb-16 relative z-10">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-16 pb-16 border-b border-[#F1F3F1]">
          
          {/* Logo and Tagline */}
          <div className="flex flex-col gap-6">
            <img 
              src={Logo} 
              alt="Cyborg Sapient" 
              className="h-10 w-auto object-contain self-start"
              loading="lazy"
            />
            <p className="text-sm font-normal text-[#5A635A] leading-relaxed max-w-xs">
              The acceleration engine behind your digital presence.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=100085886838636" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#738273] hover:text-black transition-colors duration-250" 
                aria-label="Facebook"
              >
                <FaFacebookF size={16} />
              </a>
              <a 
                href="https://www.instagram.com/cyborgsapient/?fbclid=IwY2xjawPcJgZleHRuA2FlbQIxMQBicmlkETFGT2txbXVmU2lsRFFOeUdXc3J0YwZhcHBfaWQBMAABHjvM6qnAhnal3VpNybubhSH3_UAIGdaO64lamBHJyGVoa1nEu6gzmMTGDaMP_aem_48Tq_gg8_wiFjqdAu_jkQg" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#738273] hover:text-black transition-colors duration-250" 
                aria-label="Instagram"
              >
                <FaInstagram size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links Column 1 */}
          <div>
            <h3 className="text-black font-semibold mb-6 text-xs uppercase tracking-widest">Company</h3>
            <ul className="space-y-4">
              {quickLinksCol1.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.path}
                    className="text-sm text-[#5A635A] hover:text-black transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column 2 */}
          <div>
            <h3 className="text-black font-semibold mb-6 text-xs uppercase tracking-widest">Resources</h3>
            <ul className="space-y-4">
              {quickLinksCol2.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.path}
                    className="text-sm text-[#5A635A] hover:text-black transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-black font-semibold mb-6 text-xs uppercase tracking-widest">Contact</h3>
            <div className="space-y-4 text-sm text-[#5A635A] font-normal">
              <div className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-black mt-1 flex-shrink-0" size={14} />
                <div className="space-y-2 text-xs">
                  <p><span className="font-semibold text-black">IN:</span> Pooja Garden, Kalkere, Bangalore</p>
                  <p><span className="font-semibold text-black">US:</span> 7901 4th St N #21879, St Petersburg, FL 33702</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <FaEnvelope className="text-black flex-shrink-0" size={14} />
                <a 
                  href="mailto:contact@cyborgsapient.com" 
                  className="hover:text-black transition-colors duration-200"
                >
                  contact@cyborgsapient.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-black flex-shrink-0" size={14} />
                <span>+91 9164752256</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright notice */}
        <div className="text-center text-xs text-[#738273] mt-12 font-normal">
          Copyright © 2026 <span className="text-black font-medium">Cyborgsapient.com</span>. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
